import React from 'react';
import { getEnv } from '@xbcb/ui-utils';
import { uiStageToBackendStage } from '@xbcb/ui-types';
import withModal from 'components/withModal';
import { ModalKey } from 'types';
import { useCurrentUser } from 'libs/hooks';
import { PROJECT42_FEATURE, Project42Features } from '@xbcb/feature-flags';
import DefaultModal from './defaultModal';
import Project42Modal from './project42Modal';

const { stage } = getEnv();

export interface CreateShipmentModalProps {
  closeModal: any;
  openModal: any;
}

const CreateShipmentModal = (props: CreateShipmentModalProps) => {
  const user = useCurrentUser();
  const { account } = user;
  const isProject42Enabled = PROJECT42_FEATURE.isEnabled(
    Project42Features.PROJECT42_USE_MOCK_DATA,
    {
      stage: uiStageToBackendStage[stage],
      shipper: account.id,
    },
  );

  return isProject42Enabled ? (
    <Project42Modal {...props} />
  ) : (
    <DefaultModal {...props} />
  );
};

export default withModal(ModalKey.CREATE_SHIPMENT)(CreateShipmentModal);
